import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const TriangleDownIcon = (props: Props) => {
    const { color = 'white', width = 14, height = 8, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M7 8L14 0L0 0L7 8Z" fill={color} />
        </svg>
    );
};
